/**
 * Environment and API base URLs for FlexBoard.
 *
 * Dev: `npm run dev` loads config/development/defaults.env.example.
 * Overrides: .env.development.local at repo root (gitignored).
 */

const trim = (value) => (value || "").trim();

export const isDevelopment = process.env.NODE_ENV === "development";

export const debugApi = process.env.REACT_APP_DEBUG_API === "true";

export const apiUrl = trim(process.env.REACT_APP_API_URL);

export const newApiBaseUrl = trim(process.env.REACT_APP_NEW_API_BASE_URL);

export const coachInsightsEnabled =
  process.env.REACT_APP_COACH_INSIGHTS === "true" ||
  process.env.REACT_APP_COACH_INSIGHTS === "1";

/**
 * Returns the base URL for a microservice.
 * Set REACT_APP_<SERVICE>_LOCAL_URL in .env to route that service to a local instance.
 * e.g. REACT_APP_DIET_LOCAL_URL=http://127.0.0.1:8001
 */
export function buildServiceURL(serviceName) {
  const key = serviceName.toUpperCase().replace(/-/g, "_");
  const override = trim(process.env[`REACT_APP_${key}_LOCAL_URL`]);
  if (override) return override.replace(/\/$/, "");
  const base = apiUrl.endsWith("/") ? apiUrl : `${apiUrl}/`;
  return `${base}${serviceName}/welldhan`;
}